import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getSiteContent } from '../../utils/siteContent';

const loadSlideImages = (context) => {
  return context
    .keys()
    .sort((a, b) => a.localeCompare(b))
    .map((key) => context(key));
};

const part1Context = require.context('../../assets/part1', false, /\.(png|jpe?g|webp|avif)$/i);
const part2Context = require.context('../../assets/part2', false, /\.(png|jpe?g|webp|avif)$/i);
const TRUST_SLIDES = [...loadSlideImages(part1Context), ...loadSlideImages(part2Context)];

/**
 * TrustHero Component
 * Renders the hero section specifically for the Trust Homepage.
 * Displays the main value proposition, call-to-action buttons, and building image.
 */
function TrustHero({ onViewLocations }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [siteContent, setSiteContent] = useState(() => getSiteContent());

  useEffect(() => {
    if (TRUST_SLIDES.length <= 1) return;

    const intervalId = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % TRUST_SLIDES.length);
    }, 4500);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const handleContentUpdate = () => setSiteContent(getSiteContent());
    window.addEventListener('site-content-updated', handleContentUpdate);
    return () => window.removeEventListener('site-content-updated', handleContentUpdate);
  }, []);

  return (
    <section className="hero-split-trust">
      <div className="hero-left">
        <div className="hero-value-prop">
          <h1>{siteContent.trust.heroTitle}</h1>
          <p>{siteContent.trust.heroDescription}</p>
          
          <div className="hero-cta-group">
            <Link id="trust-history-button" to="/history" className="btn-hero-primary" style={{ textDecoration: 'none' }}>View Our History</Link>
            <button id="trust-view-locations-button" type="button" className="btn-hero-secondary" onClick={onViewLocations}>View Locations</button>
            <Link id="trust-contact-button" to="/contact#trust" className="btn-hero-secondary" style={{ textDecoration: 'none' }}>Contact Us</Link>
          </div>
        </div>
      </div>

      <div className="hero-right">
        <div className="hero-top-right">
        </div>

        <div className="hero-image-wrapper hero-image-wrapper--slideshow">
          {TRUST_SLIDES.map((slideSrc, index) => (
            <div
              key={`${slideSrc}-${index}`}
              className={`hero-main-slide ${index === activeSlide ? 'is-active' : ''}`}
              style={{ backgroundImage: `url(${slideSrc})` }}
              aria-hidden={index !== activeSlide}
            />
          ))}
          <div className="hero-slide-dots hero-main-dots" aria-label="Trust hero slideshow position">
            {TRUST_SLIDES.map((_, index) => (
              <button
                key={`trust-hero-dot-${index}`}
                type="button"
                className={`hero-slide-dot ${index === activeSlide ? 'is-active' : ''}`}
                onClick={() => setActiveSlide(index)}
                aria-label={`Show trust slide ${index + 1}`}
                aria-pressed={index === activeSlide}
              />
            ))}
          </div>
          <div className="hero-main-image-overlay" />
          <div className="image-overlay-text">Building a stronger community together.</div>
        </div>
      </div>
    </section>
  );
}

export default TrustHero;
